import { CircularProgress } from "@mui/material";

const LoadingSpinner = ({ isLoading, absolute, ...props }) =>
  isLoading && (
    <CircularProgress
      size={16}
      sx={{
        position: absolute ? "absolute" : "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        ...props.sx
      }}
    />
  );

export default LoadingSpinner;
